<template>
  <div>
    <a class="button-link" data-toggle="modal" data-target="#deleteAccountModal" v-if="userId !== null">
      <i class="material-icons">delete</i>
      Delete Account
    </a>

    <div class="modal fade" id="deleteAccountModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content module">
          <div class="modal-header">
            <h1>Are you sure?</h1>
          </div>
          <hr>
          <div class="modal-body">
            <p><strong>Deleting your account will:</strong></p>
            <ul>
              <li>Remove your personal wireless network</li>
              <li>Delete or anonymize all information associated with your account</li>
            </ul>
            <br>
            <p><strong>This action can not be reversed!</strong></p>
          </div>
          <div class="modal-footer">
            <button class="modal-button" type="button" data-dismiss="modal">Cancel</button>
            <button class="modal-button red" type="button" @click="deleteAccount">Delete account</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'DeleteAccount',
    props: ['userId'],
    methods: {
      deleteAccount(){
        axios({
          method: 'delete',
          url: `/api/v1/user/${this.userId}`,
        }).then((response) => {
          if(response.status === 204){
            location.reload();
          }
        })
      }
    }
  }
</script>